import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { calculateMaterialGridTemplateColumns } from './MaterialList';
import FilterCardHeader from 'components/DesignSystems/FilterHeader/FilterCardHeader';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { Material } from 'components/IAP/hooks/useSafetyAnalysis';

const MaterialView: React.FC<{
  singleMaterial: Material;
  setIsEditing: (editing: boolean) => void;
  deleteMaterial: (id: string) => void;
  readOnly?: boolean;
}> = ({
  singleMaterial: material,
  setIsEditing,
  deleteMaterial,
  readOnly = false,
}) => {
  return (
    <FilterCardHeader
      gridTemplateColumns={calculateMaterialGridTemplateColumns(9)}
    >
      <p>{material.materialName}</p>
      <p>{material.quantity}</p>
      <p>{material.physState}</p>
      <p>{material.niosh}</p>
      <p>{material.specificGravity}</p>
      <p>{material.ph}</p>
      <p>{material.idlh}</p>
      <p>{material.flashPoint}°F</p>
      <p>{material.lel}</p>
      <p>{material.uel}</p>
      <div className="d-flex align-items-center gap-1">
        {!readOnly && (
          <>
            <StylishNewButton
              className={`button--icon`}
              onClick={(e) => {
                setIsEditing(true);
                e.stopPropagation();
              }}
            >
              <SharedIcon iconName="edit" />
            </StylishNewButton>
            <StylishNewButton
              className={`button--icon`}
              onClick={(e) => {
                if (material.id) {
                  deleteMaterial(material.id);
                }
                e.stopPropagation();
              }}
            >
              <SharedIcon iconName="delete" />
            </StylishNewButton>
          </>
        )}
      </div>
    </FilterCardHeader>
  );
};

export default MaterialView;
